<template>
    <span v-show="isShowPage">
        <v-row align="start" justify="start">
            <v-col cols="2">
                <v-text-field
                    append-icon="mdi-magnify"
                    outlined
                    solo
                    hide-details
                    v-model="search"
                    class="search"
                    placeholder="Search..."
                    v-on:keyup.enter="getDataTable()"
                    color="#2671D9"
                >
                </v-text-field>
            </v-col>
            <v-col cols="2">
              <v-menu
                v-model="dateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    style="padding: 0 !important;"
                    append-icon="mdi-chevron-down"
                    prepend-icon="mdi-calendar"
                    label="Tanggal Topup"
                    readonly
                    :value="dateDisp"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="searchDate"
                  no-title
                  range
                  locale="id-ID"
                  :min="searchDate[0] ? searchDate[0] : ''"
                ></v-date-picker>
                <v-btn
                  block
                  @click="dateMenu = false; getDataTable()"
                >
                  OK
                </v-btn>
                <v-btn
                  block
                  @click="dateMenu = false; searchDate = []; getDataTable()"
                >
                  Clear
                </v-btn>
              </v-menu>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="pt-0">
                <Table :headers="headers" :items="items" @onChangePage="getDataTable" @sortOptions="updateSortDatatable" :defaultSize="5" :loading="isFetching">
                  <template slot="nominal" slot-scope="{ item }">
                    {{ indoCurrencyFormat().format(item.nominal) }}
                  </template>
                  <template slot="paymentDate" slot-scope="{ item }">
                    {{ item.paymentDate ? dateIndo(item.paymentDate) : "" }}
                  </template>
                </Table>
            </v-col>
        </v-row>
    </span>
</template>

<script>
import Table from '../../components/Table.vue'
import MonitoringRevenueService from '@/services/default/MonitoringRevenueService'
import alert from '@/commons/helper/alert.helper'

const monitoringRevenueService = MonitoringRevenueService.build()
export default {
  name: 'monitoring-pln',
  components: {
    Table
  },
  data: () => ({
    colorActive: '#2671D9',
    colorInactive: '#9A9A9A',
    headers: [
      { value: 'namaPartner', text: 'Nama Mitra', sortable: false, align: 'left', width: '120px' },
      { value: 'phoneNumber', text: 'No. Handphone', align: 'left', width: '170px' },
      { value: 'nominal', text: 'Nominal', align: 'left', width: '180px' },
      { value: 'paymentDate', text: 'Tanggal Topup', align: 'left', width: '120px' }
    ],
    items: {},
    search: '',
    searchDate: [],
    sortSettings: '',
    isShowPage: true,
    isFetching: false,
    timer: '',
    activePicker: null,
    input: {},
    dateMenu: false
  }),
  async created () {
    // delete localStorage
    localStorage.removeItem('tableQuery')
  },
  computed: {
    dateDisp () {
      return this.searchDate.join(' ~ ')
      // format/do something with date
    }
  },
  mounted: function () {
    this.$nextTick(() => {
      // re-get data every 1 minute
      this.timer = setInterval(() => {
        const tableQuery = JSON.parse(localStorage.getItem('tableQuery'))
        if (tableQuery) {
          this.getDataTable(tableQuery.page, tableQuery.size)
        } else {
          this.getDataTable()
        }
      }, 60000)
    })
  },
  destroyed: function () {
    // kill re-get data every 1 minute
    clearInterval(this.timer)
  },
  watch: {},
  methods: {
    openDialog () {
      this.dialog = true
    },
    async resetData () {
      this.items = {}
      // this.search = ''
      this.sortSettings = ''
    },
    async getDataTable (page, size) {
      this.isFetching = true
      this.paging.page = page
      this.paging.size = size

      let tableQuery = JSON.parse(localStorage.getItem('tableQuery'))

      localStorage.setItem('tableQuery', JSON.stringify({
        page: page,
        size: size,
        sort_by: tableQuery ? tableQuery.sort_by : ''
      }))

      // re-get data after set
      tableQuery = JSON.parse(localStorage.getItem('tableQuery'))

      const param = Object.assign({
        keyword: this.search,
        sort: tableQuery ? tableQuery.sort_by : ''
      }, this.paging)
      if (this.searchDate.length > 1) {
        param.dateFrom = this.searchDate[0]
        param.dateTo = this.searchDate[1]
      } else if (this.searchDate.length === 1) {
        param.dateFrom = this.searchDate[0]
        param.dateTo = this.searchDate[0]
      }

      const response = await monitoringRevenueService.getMonitoringPartner(param)
      //   console.log(response)
      if (response?.data?.success === true) {
        if (response.data.data) {
          const { data: { data: { content, totalPages, number, size, totalElements } } } = response
          this.items = Object.assign({
            data: content,
            total: totalPages,
            size,
            page: number + 1,
            totalElements
          })
        } else {
          this.items = Object.assign({
            data: [],
            total: 0,
            size,
            page: 1,
            totalElements: 0
          })
        }
      } else {
        this.items = Object.assign({
          data: [],
          total: 0,
          size,
          page: 1,
          totalElements: 0
        })
        alert.failed(response.data.status + ' - ' + response.data.message)
      }
      this.isFetching = false
    },
    async updateSortDatatable (options) {
      if (options.sortBy) {
        this.sortSettings = ''
        for (let i = 0; i < options.sortBy.length; i++) {
          const sort = options.sortDesc[i] === false ? 'asc' : 'desc'
          let column = ''

          if (options.sortBy[i] === 'unitup') {
            column = 'unitup'
          } else if (options.sortBy[i] === 'nominal') {
            column = 'nominal'
          } else if (options.sortBy[i] === 'nominalPpj') {
            column = 'nominalPpj'
          } else if (options.sortBy[i] === 'paymentDate') {
            column = 'paymentDate'
          } else if (options.sortBy[i] === 'partnerReference') {
            column = 'partnerReference'
          }

          if (i === 0) {
            this.sortSettings += column + ',' + sort
          } else {
            this.sortSettings += '&sort=' + column + ',' + sort
          }
        }

        let tableQuery = JSON.parse(localStorage.getItem('tableQuery'))
        localStorage.setItem('tableQuery', JSON.stringify({
          page: tableQuery ? tableQuery.page : 0,
          size: tableQuery ? tableQuery.size : 20,
          sort_by: this.sortSettings
        }))
        tableQuery = JSON.parse(localStorage.getItem('tableQuery'))
        this.getDataTable(tableQuery.page, tableQuery.size)
      }
    },
    setDateRange (date) {
      this.$refs.menuDateRange.save(date)
    },
    dpTypeChooser () {
      if ((this.input.periode && this.input.periode.id === 'monthly') || (this.input.periode && this.input.periode.id === 'hourly')) return undefined
      else if (this.input.periode && this.input.periode.id === 'daily') return 'month'
      else return 'date'
    }
  }
}
</script>
